
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './paper.css';
import './paper-dark.css';
document.documentElement.classList.add('ridaz-paper');
import './firebase';
import App from './App';
import AuthPendingOverlay from './components/AuthPendingOverlay';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
    <AuthPendingOverlay />
  </React.StrictMode>
);
